import {isFreePackage, isIndividualPackage} from '@/utils/packagePolicy'

// The package quantity limits only entries shown on mvp.de. Publishing on a client's own website is unlimited.

export function findBaseTypePackage(activePackages, packageBaseType) {
  return (activePackages || []).find((pkg) => pkg?.base_type === packageBaseType) || null
}

export function contingentQuantity(pkg) {
  if (!pkg) {
    return 0
  }

  const effectiveQuantity = Number(pkg.effective_quantity ?? pkg.included_quantity ?? 0)
  if (!isIndividualPackage(pkg) || effectiveQuantity > 0) {
    return effectiveQuantity
  }

  const baseQuantity = Number(pkg.quantity ?? 0)
  const extraQuantity = Number(pkg.extra_quantity ?? 0)
  return Math.max(baseQuantity, 0) + Math.max(extraQuantity, 0)
}

export function packageTypeLabel(pkg) {
  if (isIndividualPackage(pkg)) {
    return 'Individualpaket'
  }

  return isFreePackage(pkg) ? 'Freies Paket' : 'Premium-Paket'
}

export function countMarketedObjects(objects) {
  return (objects || []).filter((object) => object?.setting_enable_in_manet_stadt_abl === true).length
}

export function placesLabel(count) {
  return `${count} ${count === 1 ? 'Platz' : 'Plätze'}`
}
